export default __webpack_public_path__ + "static/media/harbor-crop.66e3065d.jpg";